export const  columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 50,
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    {
        title: '仓库名称',
        dataIndex: 'wareName',
        key: 'wareName',
    },
    {
        title: '仓库负责人',
        dataIndex: 'wareContact',
        key: 'wareContact'
    },
    {
        title: '负责人电话',
        dataIndex: 'contactPhone',
        key: 'contactPhone',
    },
    {
        title: '仓库地址',
        dataIndex: 'address',
        key: 'address'
    },
    {
        title: '邮编',
        dataIndex: 'postalCode',
        key: 'postalCode'
    },
    // {
    //     title: '创建时间',
    //     dataIndex: 'createTime',
    //     key: 'createTime'
    // },
    {
        title: '操作',
        key: 'action',
        dataIndex: 'id',
        width: 200,
        scopedSlots: {
            customRender: 'action'
        }
    }
]